import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 25px;
`;

export const InputSearchBlock = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0px auto;
`;

export const Label = styled.label`
  min-width: 150px;
  font-size: 16px;
  cursor: pointer;
  margin: 5px;
`;

export const TagsGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  margin: 0 auto;
`;
export const H2 = styled.h1`
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
`;

export const Block = styled.div`
  margin: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const TableBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 30px;
`;
export const CourseButton = styled(Link)`
  background: #00d0b5;
  width: auto;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border-radius: 5px;
  margin-right: 5px;
  padding: 5px;
  &:hover {
    color: black;
    background: #c9ffe5;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;
export const FooterBlock = styled.div`
  height: 50px;
`;
export const UserButton = styled(Link)`
  background: #2185d0;
  width: auto;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border-radius: 5px;
  padding: 5px;
  margin-right: 5px;
  &:hover {
    background: #17ade3;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;

export const CentredBlock = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 16px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/ClientList/ClienListStyles.js